module.exports = __webpack_public_path__ + "static/media/IELTS-GeneralTrainingReading-DragDrop2.e07ce97b.png";